import {resolveBackground} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';

import NOTIFICATION_INFO from './notification-info.palette-schema.yaml';
import NOTIFICATION_ERROR from './notification-error.palette-schema.yaml';
import NOTIFICATION_WARNING from './notification-warning.palette-schema.yaml';
import NOTIFICATION_SUCCESS from './notification-success.palette-schema.yaml';

registerTileSchema(NOTIFICATION_INFO);
registerTileSchema(NOTIFICATION_ERROR);
registerTileSchema(NOTIFICATION_WARNING);
registerTileSchema(NOTIFICATION_SUCCESS);

const NOTIFICATION_TYPES = {
    INFO: 'INFO',
    ERROR: 'ERROR',
    WARNING: 'WARNING',
    SUCCESS: 'SUCCESS',
};

const ICONS_SRC_MAP = {
    [NOTIFICATION_TYPES.SUCCESS]: 'leg-status-won-icon',
};

export const generateInfoNotification = TILE => generateNotification(TILE, NOTIFICATION_TYPES.INFO);
export const generateErrorNotification = TILE => generateNotification(TILE, NOTIFICATION_TYPES.ERROR);
export const generateWarningNotification = TILE => generateNotification(TILE, NOTIFICATION_TYPES.WARNING);
export const generateSuccessNotification = TILE => generateNotification(TILE, NOTIFICATION_TYPES.SUCCESS);

function generateNotification(TILE, TYPE = NOTIFICATION_TYPES.INFO) {
    const KEYS = getPaletteKeys(NOTIFICATION_TYPES[TYPE] || NOTIFICATION_TYPES.INFO);
    const ICON_SRC = ICONS_SRC_MAP[TYPE];

    return {
        container: {
            itemSpacing: 8,
            style: {
                ...resolveBackground(TILE[KEYS.BG]),
                ...generateBorder(TILE[KEYS.BORDER]),
                padding: 8,
                height: 'auto',
                alignItems: 'center',
                ...TILE[KEYS.TEXT],
            },
        },
        text: {
            container: {
                padding: 0,
            },
            style: {
                wordBreak: 'break-word',
                ...TILE[KEYS.TEXT],
            },
        },
        icon: {
            ...(ICON_SRC ? {src: ICON_SRC} : {}),
            style: {
                fill: TILE[KEYS.ICON_COLOR],
                // Override mojito default
                minWidth: 16,
                minHeight: 16,
            },
        },
    };
}

function getPaletteKeys(PREFIX) {
    return {
        BG: `${PREFIX}_BG`,
        TEXT: `${PREFIX}_TEXT`,
        ICON_COLOR: `${PREFIX}_ICON_COLOR`,
        BORDER: `${PREFIX}_BORDER`,
    };
}
